import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useMobileOrientation, isMobileOnly } from 'react-device-detect';

import { Layout, message } from 'antd';

import Sidebar from 'components/molecules/Sidebar/Sidebar';
import ContentFrame from 'components/molecules/ContentFrame';
import GalleryHeader from 'components/atoms/GalleryHeader';
import { setLoading, setError, setGalleryParams } from 'context/actions';
import { useAppState, useAppDispatch } from 'context';
import { useRequest, UseRequestType } from 'hooks';
import config from 'config';
import { readParams, mapGalleryParams, MappedParamGroupType, SuccessErrorResponeType } from 'services/param-utils';

import './AppGalleryLayout.scss';

const { Content, Header } = Layout;

type CreativeOptions = {
  id: number,
  name: string,
};

type GalleryState = {
  idOrder: number[],
  url: string,
  creativeOptions: CreativeOptions[],
};

const AppGalleryLayout = () =>{  
  const dispatch = useAppDispatch();
  const { screenSizeClass } = useAppState();
  const { isLandscape } = useMobileOrientation();

  const [state, setState] = useState<GalleryState>({
    idOrder: [],
    url: '',
    creativeOptions: [],
  });

  const { encoded_params: encodedParams = '' } = useParams();

  const { result, error, loading }: UseRequestType = useRequest(state.url, 'GET');

  useEffect(() => {
    const validatedParams: SuccessErrorResponeType = readParams(encodedParams, 'gallery');
    const { error: validationErr, success: validationSuccess } = validatedParams;
    if (validationErr) {
      const msg = 'There was an error finding the requested creative group. Please check the url or contact support.';
      dispatch(setError({ status: 403, message: msg }));
      message.error(msg, 5); // 2nd param is duration in seconds
    }
    if (validationSuccess) {
      const paramIds: number[] = validationSuccess.map(chunk => parseInt(chunk[0], 10)); // first index always the id
      const creativeParams: MappedParamGroupType = mapGalleryParams(validationSuccess);
      setState({ ...state, idOrder: paramIds, url: `${config.api.root}/creatives/gallery/get-options?ids=${paramIds}` });      
      dispatch(setGalleryParams(creativeParams));
    }
  }, []);

  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (error) {
      dispatch(setError(error));
    }
  }, [error]);

  useEffect(() => {
    if (result.data) {
      setState({ ...state, creativeOptions: result.data });
    }
  }, [result.data]);

  return (
    <div className={`app-container ${screenSizeClass}`}>
      <Layout>
        <Sidebar hideInSmallView={true}/>
        <Layout className='app-container__main'>
          <Header className={`app-container__main__header ${isLandscape ? 'landscape' : ''} ${isMobileOnly ? 'mobile' : ''}`}>
            <GalleryHeader options={state.creativeOptions} order={state.idOrder}/>
          </Header>
          <Content className='app-container__main__body'>
            <ContentFrame/>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default AppGalleryLayout;
